import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, catchError, tap } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ReportsService extends BehaviorSubject<any[]> {
  constructor(private _http: HttpClient) {
    super([])
  }

  getCurrentRole(): Observable<any> {
    return this._http
      .get(`/settings/GetCurrentRole`, { responseType: 'text' })
      .pipe(catchError(this.handleError))
  }
  getDeletedExportBlottersReports(d: any): Observable<any> {
    return this._http
      .post<any>('/api/Types/GetDeletedBlotterExportReports', d)
      .pipe(
        tap((value) => {
          if (Array.isArray(value) && value.length === 0) {
          }
        }),
        catchError(this.handleError),
      )
  }
  getAccountFormReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetAccountFormReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getCommissionReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetCommissionReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getVaAgeReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetVaAgeReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  /*   getBlotterReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetBlotterReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  } */
  getBlotterReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Types/GetBranchTransactionsReports`, r, {
        responseType: 'blob',
      })
      .pipe(catchError(this.handleError))
  }
  getBlotterShortReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetBlotterShortReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getRepFeeReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetRepFeeReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getvaribleAnnunityAge(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetVaAgeReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getDeletedBlottersReports(d: any): Observable<any> {
    return this._http
      .post<any>('/api/Types/GetDeletedBlotterReports', d)
      .pipe(catchError(this.handleError))
  }
  getVaSummaryReport(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetVaSummaryReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getAccountReportPdf(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetAccountReportPdf`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getTransactionReportPdf(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetTransactionReportPdf`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  } //GetQuarterDate
  getGetFinCenReportPdf(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetFinCenReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getquarterdatesReports(): Observable<any> {
    return this._http
      .get<any>('/api/Reports/GetQuarterDate')
      .pipe(catchError(this.handleError))
  }
  getAccountReportExcel(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetAccountReportExcel`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getTransactionReportExcel(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetTransactionReportExcel`, r, {
        responseType: 'blob',
      })
      .pipe(catchError(this.handleError))
  }
  getCrdBranchShort(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Types/GetCrdBranchShort`)
      .pipe(catchError(this.handleError))
  }
  getRepListShort(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetListOfRepsShort`)
      .pipe(catchError(this.handleError))
  }
  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
